module.exports = __webpack_public_path__ + "static/media/29BDOS9.08ab13fb.jpg";